// flow weak 
import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Modal,
  Form,
  Table
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Redirect, Link } from "react-router-dom";
import { withRouter } from "react-router"; 
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating"; 
import "./dashboard.scss";
import noImg from "../../../img/no_img.jpg";
import noRecordFound from "../../../img/no-record-found.png";  
import ReactHtmlParser from "react-html-parser";     
import UseDfpSlot from "./UseDfpSlot";
import ScriptSlot from "./ScriptSlot";

const history = createBrowserHistory();
let isLoading = false,
  limit = 24;
function Currency(props) { 
  const cur = props.default_currency == 'EUR' ? '€' : '$';
  return <span className={props.className} >{props.default_lang=='en' ? cur : ''}{props.amount}{props.default_lang=='fr' ? cur : ''}</span>;
}
class CustomPage extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props, context) {
    super(props, context);
    this.state = { 
      sending:false,
      default_city: '',   
      multi_lang: 'no',
      lang: 'en',
      default_lang: 'en', 
      siteName: 'localhost', 
    }; 
  } 

  componentWillMount(){   
  }

  componentDidMount() { 
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus')); 
    if(siteData){
      this.setState({siteDomain: siteData.siteDomain});
      if(siteData.default_city){
        this.setState({
          default_city: siteData.default_city,   
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang, 
          siteName: siteData.siteName, 
        });
      }
    }
  } 

  componentWillReceiveProps(nextProps) {  
    if(nextProps.language) {
      this.setState({default_lang: nextProps.language});
    }
  }

  componentDidCatch(error, errorInfo) {

  }
 
  dynamicPage = (content) => {
    // if(content!='') { 
    //   content = content.replace("${UseDfpSlot}", `<UseDfpSlot />`);
    // }
    return content;
  }

  render() {   
    let topads = (this.props.customdata && this.props.customdata.topads==1 && this.props.customdata.topadsdata!='' ? JSON.parse(this.props.customdata.topadsdata) : []);
    let bottomads = (this.props.customdata && this.props.customdata.bottomads==1 && this.props.customdata.bottomadsdata!='' ? JSON.parse(this.props.customdata.bottomadsdata) : []);
    return (
      <div>
        {(this.state.sending == true || isLoading == true) ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {topads[0] &&
          (<Row style={{textAlign: 'center'}}> 
            <Col md={12} xs={12} style={{textAlign: 'center'}} >
              {topads[4] && topads[4]=='other' ? 
                <ScriptSlot datas={{ads_path:topads[0], ads_width:(topads[1] ? topads[1] : 300), ads_height:(topads[2] ? topads[2] : 250), ads_id:(topads[3] ? topads[3] : 'vsscript_87330_576309')}} />
              : 
                <UseDfpSlot datas={{ads_path:topads[0], ads_width:(topads[1] ? topads[1] : 300), ads_height:(topads[2] ? topads[2] : 250)}} />
              }
              <br />
            </Col>
          </Row>)
        }

        {ReactHtmlParser(this.dynamicPage(this.state.default_lang=='fr' ? this.props.customdata.french_content : this.props.customdata.content))}

        {bottomads[0] &&
          (<Row style={{textAlign: 'center'}}> 
            <Col md={12} xs={12} style={{textAlign: 'center'}} >
              {bottomads[4] && bottomads[4]=='other' ? 
                <ScriptSlot datas={{ads_path:bottomads[0], ads_width:(bottomads[1] ? bottomads[1] : 300), ads_height:(bottomads[2] ? bottomads[2] : 250), ads_id:(bottomads[3] ? bottomads[3] : 'vsscript_87330_576309')}} />
              :
                <UseDfpSlot datas={{ads_path:bottomads[0], ads_width:(bottomads[1] ? bottomads[1] : 300), ads_height:(bottomads[2] ? bottomads[2] : 250)}} />
              }
            </Col>  
          </Row>)
        }
      </div>
    );
  }
} 

const mapStateToProps = state => ({ 
});

export default compose(
  withRouter,
  connect(mapStateToProps)
)(CustomPage);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/CustomPage.js